import React from 'react';
import clsx from 'clsx';
import BlockTitleGroup from '../block-title-group';
import {useStyles} from './helpers';

const BlockSettingsWagering = ({formik}) => {
    const classes = useStyles();
    
    const [settingWagering, setSettingWagering] = React.useState(false);

    return (
        <div>
            <BlockTitleGroup setShowBlock={setSettingWagering} showBlock={settingWagering} title="Настройка отыгрыша" />
            {
                settingWagering && 
                <>
                    <label htmlFor="max_time_roleplaying" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                        <span className={classes.helper}>Макс. время отыгрыша (в часах)</span>
                        <input 
                            type="number" 
                            name="max_time_roleplaying" 
                            id="max_time_roleplaying" 
                            className={classes.text}
                            value={formik.values.max_time_roleplaying}
                            onChange={(v) => formik.setFieldValue('max_time_roleplaying', v.target.value)}
                        />
                    </label>
                    <div className={classes.wrapActiveBonus}> 
                        <label htmlFor="percent" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mt0)}>
                            <span className={classes.helper}>Процент</span>
                            <input 
                                type="number" 
                                name="percent" 
                                id="percent" 
                                className={classes.text}
                                value={formik.values.percent} 
                                onChange={(v) => formik.setFieldValue('percent', v.target.value)}
                            />
                        </label>
                        <label htmlFor="min_bet" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mt0)}>
                            <span className={classes.helper}>Мин. ставка</span>
                            <input 
                                type="number" 
                                name="min_bet" 
                                id="min_bet" 
                                className={classes.text}
                                value={formik.values.min_bet} 
                                onChange={(v) => formik.setFieldValue('min_bet', v.target.value)}
                            />
                        </label>
                        <label htmlFor="max_bet" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mt0)}>
                            <span className={classes.helper}>Макс. ставка</span>
                            <input 
                                type="number" 
                                name="max_bet" 
                                id="max_bet" 
                                className={classes.text}
                                value={formik.values.max_bet} 
                                onChange={(v) => formik.setFieldValue('max_bet', v.target.value)}
                            />
                        </label>
                    </div>
                </>
            }
        </div>
    )
}

export default BlockSettingsWagering;